import { FeatureFlag } from '@ps/web-core-enums';
import React from 'react';
import { useSelector } from 'react-redux';

import useFeature from '@swf/core/hooks/useFeature';
import { select } from '@swf/core/store';

import WalletApolloProvider from '../providers/WalletApolloProvider';

import BigWinningsSubscription from './BigWinningsSubscription';
import NotificationServiceSubscriptions from './NotificationServiceSubscriptions';

const GQLClientSubscriptions: React.FC = () => {
  const { idpToken } = useSelector(select.session.get);
  const { apiDomain } = useSelector(select.config.get);
  const enableGQLSubscription = useFeature(FeatureFlag.EnableNotificationServiceGQLSubscription);

  if (!idpToken || !apiDomain) return null;

  // cleanup below code after integration of BigWinnigs subscription into NotificationService and extend with upcoming GQL subscriptions
  return (
    <>
      {enableGQLSubscription && <NotificationServiceSubscriptions />}
      <WalletApolloProvider>
        <BigWinningsSubscription />
      </WalletApolloProvider>
    </>
  );
};

export default GQLClientSubscriptions;
